import axios from "axios";

// Default to Laravel API prefix so relative calls hit the backend instead of the React dev server
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api",
});

// Attach Passport Bearer token from localStorage
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;
